import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import moment from "moment";

import { useStyles } from "./ViewStaffAttendance.css";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import StaffAttendanceBody from "../StaffAttendanceBody/StaffAttendanceBody";
import { url } from "../../../../../Config/Config";
import Axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewStaffAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Staff Name" },
        { name: "Department" },
        { name: "Designation" },
        { name: "Status" },
        { name: "Remarks" },
        { name: "Actions" },
      ],
      date: moment(new Date()).format("YYYY-MM-DD"),
      staffList: [],
      staffAttendanceList: [],
    };
  }

  componentDidMount() {
    this.getStaffList();
  }

  getStaffList = async () => {
    try {
      const response = await Axios.get(`${url}/api/staffs`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      let staffList = [];
      if (response.data.staffs.length !== 0) {
        response.data.staffs.map((staff) =>
          staffList.push({
            staffId: staff._id,
            status: "P",
            date: moment(new Date()).format("YYYY-MM-DD"),
          })
        );
        this.getStaffAttendance();

        this.setState({
          staffList,
          isEmpty: false,
        });
      } else {
        this.setState({
          staffList: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStaffList();
      }
    }
  };

  getStaffAttendance = async () => {
    try {
      const response = await Axios.get(`${url}/api/staff-attendance`, {
        params: {
          date: moment(new Date()).format("YYYY-MM-DD"),
        },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      let staffAttendanceList = [];
      if (response.data.attendances.length !== 0) {
        for (let i = 0; i <= response.data.attendances.length - 1; i++) {
          staffAttendanceList.push({
            attendanceId: response.data.attendances[i]._id,
            staffId: response.data.attendances[i].staffId,
            status: response.data.attendances[i].status,
            remarks: response.data.attendances[i].remarks
              ? response.data.attendances[i].remarks
              : "",
            date: response.data.attendances[i].date,
          });
        }
        this.setState({
          staffAttendanceList,
        });
      } else {
        const response = await Axios.put(
          `${url}/api/staff-attendance/bulk`,
          { staffAttendances: this.state.staffList },
          {
            headers: { Authorization: `Bearer ${this.props.adminToken}` },
          }
        );
        if (response.data.message === "Bulk attendance successfull") {
          this.getStaffAttendance();
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStaffAttendance();
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Employee Attendance"
            refreshUrl={this.props.match.url}
          />

          <div>
            <b>Attendance Date :-</b> {moment(this.state.date).format("LL")}
          </div>

          {this.state.staffAttendanceList.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  {this.state.staffAttendanceList.map((staff, index) => (
                    <StaffAttendanceBody
                      key={index}
                      index={index}
                      data={staff}
                      getStaffAttendance={this.getStaffAttendance}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage description="No staff is present in the database" />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewStaffAttendance)));
